import { render } from "./ClassList.vue?vue&type=template&id=8a61ce58&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"

import "./ClassList.vue?vue&type=style&index=0&id=8a61ce58&lang=scss"
import "./ClassList.vue?vue&type=style&index=1&id=8a61ce58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a61ce58"]])

export default __exports__